export const isEventInPlay = () => { var _a, _b; return (_b = (_a = window.WH) === null || _a === void 0 ? void 0 : _a.byo) === null || _b === void 0 ? void 0 : _b.byoInPlay; };
